import React, { useEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import {
    GetDataForExpensePolicyPerDiemRateAsync, resetSelectedRecordObjectInState,
    resetDefaultCategory, GetAccountExpensePolicyPerDiemRateForAddEditForDefaultAsync,
    GetAccountExpensePolicyPerDiemRateForAddEditLocationRateAsync, updateForDefaultRate,
    UpdateAccountExpensePolicyPerDiemLocationId, deleteAllSelectedRecordExpensePolicyPerDiemAsync,updatePagination
} from "./expensePolicyPerDiemSlice";
import ExpensePolicyPerDiemItem from "./ExpensePolicyPerDiemItems";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import ExpensePolicyPerDiemForm from "./ExpensePolicyPerDiemForm";
import { Link, useLocation } from 'react-router-dom';
import { ShowSwal, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import ExpensePolicyPerDiemOffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import { DatabaseCheck, Display } from "react-bootstrap-icons";
import { ShowToast } from "../../../common/Toastr";
import { useFormik } from "formik";
import * as yup from 'yup';
import { useTranslation } from "react-i18next";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import CustomPagination from "../../../common/Pagination";
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList, sortData } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import PageSizeSelect from '../../../common/PageSizeSelect';


const ExpensePolicyPerDiem = (props: any) => {
    const { onhandleOnClickEvent } = props;
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { expensePolicyPerDiemTypeList, expensePolicyPerDiemDetailList, isReload,isLoading,  sortOrder, sortColumn, search, pageNo, pageSize, DefaultExpenseCatId, AccountExpensePolicyPerDiemLocationRateId, AccountExpensePolicyPerDiemLocationId } = useAppSelector((state) => state.expensePolicyPerDiem);
    const modelRef = useRef<any>(null);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete,sessionAccountEmployeeId,maxMenuHeight, accountBaseCurrencyId } = useAppSelector((state) => state.globalState);
    const { MasterExpensePolicyId} = useAppSelector((state) => state.expensePolicy);
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
     const navigate = useNavigate();
    const location = useLocation();
   const { obj } = location.state || {};    
    const storedObjectData = localStorage.getItem('objExpensePolicyItem');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
    let AccountExpensePolicyId = '00000000-0000-0000-0000-000000000000';
     if (MasterExpensePolicyId && MasterExpensePolicyId !== '') {
        AccountExpensePolicyId = MasterExpensePolicyId;
     } else if (obj && obj.AccountExpensePolicyId) {
        AccountExpensePolicyId = obj.AccountExpensePolicyId;
     } else if(objectData && objectData.AccountExpensePolicyId){
        AccountExpensePolicyId = objectData.AccountExpensePolicyId;
     }else
     {
         navigate('../expensepolicy');
     }
    const [selectedOptionExpenseType, setselectedOptionExpenseType] = useState<{ [object: string]: any }>();
    const [expenseTypeArray, SetexpenseTypeArray] = useState<any | ''>([]);
    const [buttonId, setButtonId] = useState(false);
    const [ddlCategoryId, setddlCategoryId] = useState(0);

    const getDefaultCategoryByExpensePolicyId = async () => {
        const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/GetAccountExpensePolicyPerDiemId/' + AccountExpensePolicyId, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();

        if (json.length > 0) {
            getDefaultCategories(json[0].DefaultExpenseCategoryPerDiemId);
            dispatch(resetDefaultCategory(json[0].DefaultExpenseCategoryPerDiemId));
        } else {
            getDefaultCategories(0);
        }

    }

    const getDefaultCategories = async (value: any) => {

        const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/GetDataForDefaultExpenseCategory/' + value, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.AccountExpenseId;
            item.label = item.AccountExpenseName;
            delete item.AccountExpenseId;
            delete item.AccountExpenseName;
            if (item.value == value) {
                setselectedOptionExpenseType({ value: value, label: item.label });
            }
        });
        SetexpenseTypeArray(json);
    }
    useEffect(() => {
        getDefaultCategoryByExpensePolicyId();
    }, [])


    // const handlePageChange = (pageNumber: any) => {
    //     setCurrentPage(pageNumber);
    // };
    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     setSearchTerm(value);
    //     setCurrentPage(1);
    // };

    // const handlePageSizeChange = (selectedOption: any) => {
    //     const { value, label } = selectedOption;
    //     setPageSize(Number(value));
    //     setCurrentPage(1);
    // };

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const filteredData: any = getFilteredList(expensePolicyPerDiemDetailList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = expensePolicyPerDiemDetailList.length;
    const recordsFiltered = filteredData.length;

    // const filteredData: any = getFilteredList(expensePolicyPerDiemDetailList, searchTerm);



    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = Object.values(expensePolicyPerDiemDetailList).length;
    // const recordsFiltered = filteredData.length;

    useEffect(() => {
        if (isReload) {
            dispatch(GetDataForExpensePolicyPerDiemRateAsync(AccountExpensePolicyId));
        }

    }, [isReload])

    useEffect(() => {
        dispatch(GetDataForExpensePolicyPerDiemRateAsync(AccountExpensePolicyId));
    }, [dispatch])


    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
        .then((result) => {
            if (result) {
                dispatch(deleteAllSelectedRecordExpensePolicyPerDiemAsync(expensePolicyPerDiemDetailList))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        originalPromiseResult[0].StatusCode === "200" ?
                            ShowToast('Per diem deleted Successfully', 'Success', "success", "toast-top-right") :
                            ShowToast('error', originalPromiseResult[0].message, "error", "toast-top-right");
                        dispatch(GetDataForExpensePolicyPerDiemRateAsync(AccountExpensePolicyId));
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        console.log('Not Delete-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                    })
            }
        })
        .catch((error) => {
            console.log("ShowSwalWithConfirmation:error ", error);
        });
    }

    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const handleChange = (data: any) => {
        const { value, label } = data;
        setselectedOptionExpenseType({ value: value, label: label });
        const ddlCategory = value;
        dispatch(resetDefaultCategory(ddlCategory));
    }
    const handleOnClickDefaultRateEvent = () => {
        if (selectedOptionExpenseType !== undefined) {
            dispatch(resetSelectedRecordObjectInState());
            const defaultitem = expensePolicyPerDiemDetailList.find(item => item.PerDiemLocationName === 'Default Rate');
            const LocationId = defaultitem ? defaultitem.AccountExpensePolicyPerDiemLocationId : null;
            dispatch(UpdateAccountExpensePolicyPerDiemLocationId(LocationId == null ? 0 : LocationId));
            dispatch(updateForDefaultRate(true));
            dispatch(GetAccountExpensePolicyPerDiemRateForAddEditForDefaultAsync({ "Default Rate": 'True', "AccountExpensePolicyPerDiemLocationRateId": 0 }));
            onhandleOnClickEvent({ name: 
                // t('Add Per Diem')
                getValueFromResource('Add Per Diem',dispatch, t)
                , width: '800px', componentName: <ExpensePolicyPerDiemForm /> })
        } else {
            ShowSwal('DEFAULT CATEGORY', "Please Select Default Category", "warning");
            if (closeButtonRef.current) {
                closeButtonRef.current.click();
            }
        }

    }

    const handleOnClickLocationRateEvent = () => {
        if (selectedOptionExpenseType !== undefined) {
            dispatch(updateForDefaultRate(false));
            dispatch(resetSelectedRecordObjectInState());
            setButtonId(false);
            dispatch(GetAccountExpensePolicyPerDiemRateForAddEditLocationRateAsync({ 'AccountExpensePolicyPerDiemLocationRateId': 0 }));
            setButtonId(false);
            onhandleOnClickEvent({ name: 
                // t('Add Per Diem'),
                getValueFromResource('Add Per Diem',dispatch, t),
                 width: '800px', componentName: <ExpensePolicyPerDiemForm /> })
        } else {
            ShowSwal('DEFAULT CATEGORY', "Please Select Default Category", "warning");
            if (closeButtonRef.current) {
                closeButtonRef.current.click();
            }
        }

    }
    return (
        <>
               {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('Per Diem List')} */}
                        {getValueFromResource('Per Diem List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                    <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                          /> */}
                           <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}

                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}

                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div style={{display: expensePolicyPerDiemDetailList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}>
                            <Select
                                value={selectedOptionExpenseType}
                                className="basic-single"
                                classNamePrefix="Select Category"
                                isSearchable={true}
                                name="expenseTypeArray"
                                onChange={handleChange}
                                options={expenseTypeArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />

                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <a id="kt_OffCanvas"
                            className='btn btn-sm btn-primary'
                            style={{ marginRight: '2px', display: expensePolicyPerDiemDetailList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            onClick={handleOnClickDefaultRateEvent}>
                            <KTIcon iconName='plus' className='fs-3' />
                            {/* {t('Add Default Rate')} */}
                            {getValueFromResource('Add Default Rate',dispatch, t)}
                        </a>
                        <a id="kt_OffCanvas"
                            className='btn btn-sm btn-primary'
                            style={{ marginRight: '2px', display: expensePolicyPerDiemDetailList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            onClick={handleOnClickLocationRateEvent}>
                            <KTIcon iconName='plus' className='fs-3' />
                            {/* {t('Add Location Rates')} */}
                            {getValueFromResource('Add Location Rates',dispatch, t)}
                        </a>


                        <>
                            <div className="text-muted me-5" style={{ marginRight: '2px', display: Object.values(expensePolicyPerDiemDetailList).some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                <span className="me-2" data-kt-user-table-select="selected_count">{Object.values(expensePolicyPerDiemDetailList).filter((item: any) => item.isSelected === 1).length}</span>
                                 {/* {t('Selected')} */}
                                 {getValueFromResource('Selected',dispatch, t)}
                            </div>
                            <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                style={{ marginRight: '2px', display: Object.values(expensePolicyPerDiemDetailList).some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                            >
                                <i className="bi bi-trash fs-5 me-2"></i>
                                {/* {t('Delete')} */}
                                {getValueFromResource('Delete',dispatch, t)}
                            </button>
                            <button
                                ref={closeButtonRef}
                                type="button"
                                className="btn btn-light btn-sm me-2"
                                id="kt_OffCanvas"
                                onClick={handleCloseOnClickEvent}
                                style={{ display: 'none' }}
                            >
                                  {/* {t('Cancel')} */}
                                  {getValueFromResource('Cancel',dispatch, t)}
                            </button>
                        </>

                    </div>
                </div>

                {/* <div className="card-body"> */}
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <ExpensePolicyPerDiemItem expensePolicyPerDiemDetailList={filteredData} onhandleOnClickEvent={onhandleOnClickEvent} />
                    </div>
                </div>
            </div>
        </>
    )
    
}
const Styles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 200, minHeight: '36px', height: '36px', padding: '-1px' }),
}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}
const divStyle = {
    margin: '3px',
};
export default ExpensePolicyPerDiem;